import { Expression } from './expression';
export class Ordering {
    static property(property) {
        return this.expression(Expression.property(property));
    }
    static expression(expression) {
        return new SortOrder(expression);
    }
}
export class SortOrder extends Ordering {
    constructor(expression) {
        super();
        this.expression = expression;
        this.isAscending = true;
    }
    ascending() {
        this.isAscending = true;
        return this;
    }
    descending() {
        this.isAscending = false;
        return this;
    }
    asJSON() {
        if (this.isAscending) {
            return this.expression.asJSON();
        }
        return ['DESC', this.expression.asJSON()];
    }
}
//# sourceMappingURL=ordering.js.map